import PropTypes from 'prop-types';

import Modal from 'honeydew/Modal';

export const PRICING_COPY_VARIANTS = ['Private label', 'Produce', 'Grocery'];

export const getPricingCopyVariant = ({ brand = '', l1TaxonomyName = '' }) => {
    const isPrivateLabelBrand = ['odds & ends', 'imperfect foods'].includes(brand?.toLowerCase());

    let pricingCopyVariant = '';

    if (isPrivateLabelBrand) {
        pricingCopyVariant = 'Private label';
    } else if (l1TaxonomyName === 'Produce') {
        pricingCopyVariant = l1TaxonomyName;
    } else if (brand && !isPrivateLabelBrand && l1TaxonomyName && l1TaxonomyName !== 'Produce') {
        pricingCopyVariant = 'Grocery';
    }

    return pricingCopyVariant;
};

function PricingModal({ copyVariant, open, sale, setOpen }) {
    return (
        <Modal open={open} onClose={() => setOpen(false)}>
            <section className="mx-auto max-w-[584px] pb-30">
                <h1 className="text-heading-md">How is this calculated?</h1>
                <p className="text-body-sm mt-40 text-grey">
                    {copyVariant === 'Private label' && (
                        <>
                            When possible, we compare our brand&apos;s price to national brand equivalents&apos;
                            suggested retail prices. If standard suggested retail prices are not available, we compare
                            our brand&apos;s price to that of various grocery stores and online retailers for products
                            of similar quality.
                        </>
                    )}
                    {copyVariant === 'Produce' && (
                        <>
                            We calculate our savings by comparing our price to that of various grocery stores and online
                            retailers for the same (or similar) item.
                        </>
                    )}
                    {copyVariant === 'Grocery' && (
                        <>
                            We calculate our savings by comparing our price to that of various grocery stores and online
                            retailers, as well as the product&apos;s manufacturer&apos;s suggested retail price (MSRP).
                        </>
                    )}
                </p>
                {sale && (
                    <>
                        <h2 className="text-body-lg mt-40 font-grotesk-bold">This item is on sale!</h2>
                        <p className="text-body-sm mt-20 text-grey">
                            A sale price indicates an even deeper, limited-time savings compared to an item&apos;s
                            everyday price in our store (which may already be discounted). The percent savings reflects
                            the difference between its grocery store price (the amount in strikethrough) and our current
                            price.
                        </p>
                    </>
                )}
            </section>
        </Modal>
    );
}

PricingModal.propTypes = {
    copyVariant: PropTypes.oneOf(PRICING_COPY_VARIANTS).isRequired,
    open: PropTypes.bool.isRequired,
    sale: PropTypes.bool,
    setOpen: PropTypes.func.isRequired,
};

PricingModal.defaultProps = {
    sale: false,
};

export default PricingModal;
